<template>
  <div class="coupon">
    <fixed-header :showRule="true" title="优惠券" @edit="showRule=true"></fixed-header>
    <div class="coupon__main">
      <i v-if="showIcon" class="icon help" @click="showRule=true"></i>
      <coupon-item :list="couponList" :noSelcet="1" :readonly="1"></coupon-item>
    </div>
    <div class="coupon__footer">
      <div class="coupon__footer-title">优惠券码</div>
      <div class="coupon__footer-input">
        <div>
          <input v-model="couponCode" placeholder="请输入优惠券码" type="text" @blur="handleBlur" @focus="handleFocus">
        </div>
        <span mg-stat-click mg-stat-custom="label=btn&cont=领取&direct=cntp&addr=w_coupon_rule"
              mg-stat-mod="coupon_receive"
              @click="submitGetCoupon">领取</span>
      </div>
    </div>

    <select-coupon :couponList="couponList" :visible="showRule" from="coupon" @close="showRule=false"></select-coupon>
  </div>
</template>
<script>
import FixedHeader from 'components/common/FixedHeader';
import CouponItem from 'components/common/CouponItem';
import SelectCoupon from 'components/common/SelectCoupon';
import * as couponApis from 'apis/coupon';
import Env from 'utils/env';


export default {
  components: {
    CouponItem, FixedHeader, SelectCoupon,
  },
  data() {
    return {
      showRule: false,
      couponList: [],
      couponCode: '',
    };
  },
  computed: {
    showIcon() {
      return Env.isWeixin || Env.isWeiBo || Env.isQQ || Env.isMgtvApp;
    },
  },
  created() {
    this.fetchCouponList();
    this.setCouponStatus();
  },
  methods: {
    async setCouponStatus() {
      await couponApis.readCoupon();
    },
    async fetchCouponList() {
      try {
        const data = await couponApis.getCouponList();
        if (Array.isArray(data)) {
          this.couponList = data;
        }
      } catch (error) {
        this.$toast(`获取优惠券失败：${error.message}`);
      }
    },
    async submitGetCoupon() {
      const { couponCode } = this;
      if (!couponCode) {
        this.$toast({
          message: '请输入优惠券码',
          iconClass: 'icon toast_error',
          duration: 1000,
        });
        return;
      }
      try {
        await couponApis.exchangeCoupon({ code: couponCode });
        this.$toast({
          message: '领取成功',
          iconClass: 'icon selected',
          duration: 1000,
        });
        this.fetchCouponList();
      } catch (error) {
        this.$toast({
          message: `领取失败：${error.message}`,
          iconClass: 'icon toast_error',
          duration: 1000,
        });
      }
    },
    handleBlur(event) {
      event.target.scrollIntoView(false);
    },
    handleFocus(e) {
      setTimeout(() => {
        e.target.scrollIntoView(true);
      }, 100);
    },
  },
};
</script>
<style lang="scss">
.coupon {
  height: 100%;
  box-sizing: border-box;
  position: relative;

  &__main {
    height: 100%;
    width: 100%;
    padding-bottom: 120px;
    padding-top: 20px;
    background: #fff;
    box-sizing: border-box;

    i {
      position: absolute;
      display: block;
      right: 30px;
      top: 22px;
      z-index: 200;
    }
  }

  &__footer {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 40px 30px;
    background: #fff;
    display: flex;

    &-title {
      height: 56px;
      line-height: 56px;
      font-size: 26px;
      color: #4a4a4a;
      margin-right: 12px;
    }

    &-input {
      display: flex;
      flex: 1;

      div {
        box-sizing: border-box;
        border: 1px solid #d6d6d6;
        width: 80%;
        padding: 12px 15px;
        display: flex;
        align-items: center;
        height: 56px;
      }

      input {
        width: 100%;
        font-size: 22px;
      }

      span {
        height: 56px;
        line-height: 56px;
        width: 20%;
        font-size: 22px;
        color: #fff;
        text-align: center;
        background: #fd720f;
        border-radius: 6px;
        margin-left: -4px;
      }
    }
  }
}
</style>
